import { Text, View, Image } from '@react-pdf/renderer';
import { dateFormat } from '../../../../../lib/format/format';

export const PdfAccountInformation = (account, styles) => {
  const { grdRow, grdCell, grdHeader, grdSubHeader, BB, BL, BR, label, text, nM } =
    styles;

  let accountTypeDisplay = '';

  switch (account.accountType) {
    case 'I':
      accountTypeDisplay = 'Individual';
      break;
    case 'C':
      accountTypeDisplay = 'Corporation';
      break;
    case 'J':
      accountTypeDisplay = 'Joint';
      break;
    case 'IRA':
      accountTypeDisplay = 'Individual Retirement Account';
      break;
    default:
      accountTypeDisplay = account.accountType;
  }

  return (
    <View style={[grdRow]}>
      <View style={[grdCell]}>
        <View style={[grdHeader]}>
          <Text>Account Information</Text>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>First Name:</Text>
            <Text style={[text]}>{account.primaryOwner.firstName}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Middle Name:</Text>
            <Text style={[text]}>{account.primaryOwner.middleName}</Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
            <Text style={label}>Last Name:</Text>
            <Text style={[text]}>{account.primaryOwner.lastName}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Email Address:</Text>
            <Text style={[text]}>{account.primaryOwner.email}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Phone Number:</Text>
            <Text style={[text]}>{account.primaryOwner.phone}</Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
            <Text style={label}>Birth Date:</Text>
            <Text style={[text]}>
              {dateFormat(account.primaryOwner.identification.dateOfBirth)}
            </Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 50 }]}>
            <Text style={label}>Address:</Text>
            <Text style={[text]}>
              {account.primaryOwner.address1} {account.primaryOwner.address2}
            </Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
            <Text style={label}>City:</Text>
            <Text style={[text]}>{account.primaryOwner.city}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>State:</Text>
            <Text style={[text]}>{account.primaryOwner.state}</Text>
          </View>
          <View style={[grdCell, BB, BL, { width: 33.33 }]}>
            <Text style={label}>Zip Code:</Text>
            <Text style={[text]}>{account.primaryOwner.zip}</Text>
          </View>
          <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
            <Text style={label}>Country:</Text>
            <Text style={[text]}>{account.primaryOwner.country}</Text>
          </View>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BL, BR, { width: 50 }]}>
            <Text style={label}>Account Type:</Text>
            <Text style={[text]}>{accountTypeDisplay}</Text>
          </View>
          {(account.accountType === 'J' ||
            account.accountType === 'C' ||
            account.accountType === 'IRA') && (
            <View style={[grdCell, BR, { width: 50 }]}>
              <Text style={label}>Sub Account Type:</Text>
              <Text style={[text]}>{account.subType}</Text>
            </View>
          )}
        </View>
        <View style={[grdSubHeader, { textAlign: 'center' }]}>
          <Text>Proof of Address:</Text>
        </View>
        <View style={[grdRow, nM]}>
          <View style={[grdCell, BB, BL, BR]}>
            {account.primaryOwner.imgProofOfAddress ? (
              <Image
                style={styles.imageThumbnail}
                src={{ uri: account.primaryOwner.imgProofOfAddress, method: 'GET' }}
              />
            ) : (
              <Text style={[{ textAlign: 'center' }]}>No proof of address provided.</Text>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};
